<template>
  <div class="after-sales">
    <el-card shadow="never" class="filter-card">
      <div class="filter-row">
        <div class="status-btns">
          <el-button
            v-for="item in statusTabs"
            :key="item.value"
            :type="currentStatus === item.value ? 'danger' : 'default'"
            size="small"
            round
            @click="switchStatus(item.value)"
          >
            {{ item.label }}
            <span v-if="item.count !== undefined" class="count-badge">({{ item.count }})</span>
          </el-button>
        </div>
        <div class="search-box">
          <el-select v-model="typeFilter" placeholder="售后类型" size="small" style="width:120px" clearable @change="searchData">
            <el-option label="全部" :value="''" />
            <el-option label="退货退款" :value="1" />
            <el-option label="仅退款" :value="2" />
          </el-select>
          <el-input v-model="searchKey" placeholder="售后单号/订单号" size="small" style="width:220px" clearable @keyup.enter.native="searchData" />
          <el-button type="primary" size="small" @click="searchData">搜索</el-button>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" style="margin-top:16px">
      <el-table :data="tableData" border stripe v-loading="loading" @row-click="goDetail" style="cursor:pointer">
        <el-table-column prop="after_sale_no" label="售后单号" width="200" />
        <el-table-column prop="order_no" label="订单号" width="180" />
        <el-table-column label="会员" width="150">
          <template slot-scope="scope">
            <div>{{ scope.row.member_name || '-' }}</div>
            <div style="font-size:12px;color:#909399">{{ scope.row.member_phone || '' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="售后类型" width="90">
          <template slot-scope="scope">{{ scope.row.after_sale_type_text }}</template>
        </el-table-column>
        <el-table-column label="退款金额" width="110">
          <template slot-scope="scope">
            <span class="amount-text">&yen;{{ scope.row.refund_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="售后状态" width="140">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)" size="small">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="申请时间" width="160" />
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 0" type="danger" size="mini" @click.stop="openAudit(scope.row, 'pass')">通过</el-button>
            <el-button v-if="scope.row.status === 0" type="info" size="mini" @click.stop="openAudit(scope.row, 'reject')">拒绝</el-button>
            <el-button v-if="scope.row.status === 2" type="warning" size="mini" @click.stop="openSign(scope.row)">确认签收</el-button>
            <el-button type="text" size="mini" @click.stop="goDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination background layout="total, prev, pager, next" :total="total" :page-size="15" :current-page="page" @current-change="onPageChange" />
      </div>
    </el-card>

    <!-- 审核弹窗 -->
    <el-dialog :title="auditAction === 'pass' ? '审核通过' : '审核拒绝'" :visible.sync="auditDialogVisible" width="450px">
      <p style="margin-bottom:12px">售后单号：<strong>{{ currentRow.after_sale_no }}</strong></p>
      <p style="margin-bottom:12px">订单号：{{ currentRow.order_no }}</p>
      <p style="margin-bottom:12px">售后类型：{{ currentRow.after_sale_type_text }}，退款金额：<span class="amount-text">&yen;{{ currentRow.refund_amount }}</span></p>
      <el-input v-model="auditRemark" type="textarea" :rows="3" placeholder="审核备注（选填）" />
      <div slot="footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button :type="auditAction === 'pass' ? 'danger' : 'info'" @click="submitAudit">确认{{ auditAction === 'pass' ? '通过' : '拒绝' }}</el-button>
      </div>
    </el-dialog>

    <!-- 签收弹窗 -->
    <el-dialog title="确认签收" :visible.sync="signDialogVisible" width="400px">
      <p style="margin-bottom:12px">售后单号：<strong>{{ currentRow.after_sale_no }}</strong></p>
      <p style="margin-bottom:12px">物流公司：{{ currentRow.return_express_company || '-' }}</p>
      <p style="margin-bottom:12px">快递单号：{{ currentRow.return_express_no || '-' }}</p>
      <p>确认已收到退货商品，将自动执行退款？</p>
      <div slot="footer">
        <el-button @click="signDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitSign">确认签收</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAfterSales, auditAfterSale, signAfterSale } from '@/api'

export default {
  name: 'AfterSales',
  data() {
    return {
      currentStatus: '',
      statusTabs: [
        { label: '全部', value: '', count: 0 },
        { label: '待审核', value: 0, count: 0 },
        { label: '待退货', value: 1, count: 0 },
        { label: '待签收', value: 2, count: 0 },
        { label: '退款完成', value: 4, count: 0 }
      ],
      typeFilter: '',
      searchKey: '',
      tableData: [],
      loading: false,
      total: 0,
      page: 1,
      auditDialogVisible: false,
      auditAction: 'pass',
      auditRemark: '',
      currentRow: {},
      signDialogVisible: false
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = { page: this.page, limit: 15 }
        if (this.currentStatus !== '') params.status = this.currentStatus
        if (this.typeFilter !== '') params.after_sale_type = this.typeFilter
        if (this.searchKey) params.keyword = this.searchKey
        const res = await getAfterSales(params)
        this.tableData = res.list || []
        this.total = res.total || 0
        if (res.statusCounts) {
          this.statusTabs[0].count = (res.statusCounts.pending_audit || 0) + (res.statusCounts.audit_pass || 0) + (res.statusCounts.shipped || 0) + (res.statusCounts.refunded || 0)
          this.statusTabs[1].count = res.statusCounts.pending_audit || 0
          this.statusTabs[2].count = res.statusCounts.audit_pass || 0
          this.statusTabs[3].count = res.statusCounts.shipped || 0
          this.statusTabs[4].count = res.statusCounts.refunded || 0
        }
      } catch (e) {
        this.$message.error('获取售后列表失败')
      }
      this.loading = false
    },
    switchStatus(val) {
      this.currentStatus = val
      this.page = 1
      this.loadData()
    },
    searchData() {
      this.page = 1
      this.loadData()
    },
    onPageChange(page) {
      this.page = page
      this.loadData()
    },
    statusTagType(status) {
      const map = { 0: 'warning', 1: 'info', 2: '', 3: 'info', 4: 'success', 5: 'danger', 6: 'info' }
      return map[status] || 'info'
    },
    openAudit(row, action) {
      this.currentRow = row
      this.auditAction = action
      this.auditRemark = ''
      this.auditDialogVisible = true
    },
    async submitAudit() {
      try {
        await auditAfterSale({
          after_sale_id: this.currentRow.id,
          audit_result: this.auditAction,
          audit_remark: this.auditRemark
        })
        this.$message.success(this.auditAction === 'pass' ? '审核通过' : '已拒绝')
        this.auditDialogVisible = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    openSign(row) {
      this.currentRow = row
      this.signDialogVisible = true
    },
    async submitSign() {
      try {
        await signAfterSale({ after_sale_id: this.currentRow.id })
        this.$message.success('签收成功，退款处理中')
        this.signDialogVisible = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    goDetail(row) {
      this.$router.push({ name: 'AfterSaleDetail', params: { id: row.id } })
    }
  }
}
</script>

<style scoped>
.filter-card { margin-bottom: 0; }
.filter-row { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; }
.status-btns { display: flex; gap: 8px; }
.count-badge { color: #3a8ee6; }
.search-box { display: flex; gap: 8px; }
.amount-text { color: #3a8ee6; font-weight: bold; }
.pagination-box { text-align: right; margin-top: 16px; }
</style>
